import React, {Component} from 'react'
import {Route, Switch, withRouter} from 'react-router-dom'
import {MDBAlert, MDBContainer} from "mdbreact";
import Profile from "./Profile/Profile";
import HistoryReply from "./HistoryReply/HistoryReply";
import classes from './MemberLayout.module.css'
import {connect} from "react-redux";
import MyCollection from "./MyCollection/MyCollection"
import MyPost from "./MyPost/MyPost"


class MemberLayout extends Component{
    constructor(props) {
        super(props);
        this.state={

        }
    }

    render() {
        return (
            <div>
                <MDBContainer>
                    <MDBAlert color="warning">
                        Welcome Back! User
                    </MDBAlert>
                </MDBContainer>
                <hr/>
                <Switch>
                    <div className={classes.AdminContainer}>
                        <Route path="/m/profile" exact
                               component={Profile}/>
                        <Route path="/m/history" exact
                               component={HistoryReply}/>
                        <Route path="/m/collection" exact
                               component={MyCollection}/>
                        <Route path="/m/post" exact
                               component={MyPost}/>


                    </div>
                </Switch>
            </div>
        );
    }
}

export default MemberLayout